import React from 'react';

import { StyledHeader } from './Header.styled';
import { StyledNavLink } from './NavLink.styled';

import { ReactComponent as Logo } from '../../assets/logo.svg';

const Header = () => {
  return (
    <StyledHeader>
      <div className="logo">
        <Logo className="logo__svg" />
      </div>
      <nav className="navbar">
        <StyledNavLink to={'/'}>Home</StyledNavLink>
        <StyledNavLink to={'/articles'}>Articles</StyledNavLink>
      </nav>
    </StyledHeader>
  );
};

export default Header;
